import React from "react"
import styled from "styled-components"
import configStyles from "../../../../customize-styles"
import { setThemeVars } from "../../../util/theme-helper"

const GoogleAdSenseSearch = () => {
  
  const cx = 'b4f5521e21c4e00ce';
  let gcse = document.createElement('script');
  gcse.type = 'text/javascript';
  gcse.async = true;
  gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
  let s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(gcse, s);
  return (
    <StyledDiv>
      <div className="gcse-search"></div>
    </StyledDiv>
  )
}

export default GoogleAdSenseSearch

const StyledDiv = styled.div`
  .gsc-control-cse{
    padding:0
  }
  td{
    border-bottom:0;
    padding:0;
  }
  .gsib_a{
    padding:0 8px;
    line-height:1rem;
  }
  #gs_cb50{
    line-height:1rem;
  }
  #gs_st50{
    height:16px;
  }
  table{
    overflow:hidden;
  }
  .gsc-search-button{
    height:36px;
  }
  table.gsc-search-box td.gsc-input{
    padding-right:0;
  }
  .gsc-control-cse{
    border-color:transparent;
    background-color:transparent;
  }
  .gsc-input-box{
    border-color:${()=>setThemeVars( configStyles.fontSubColorLight,configStyles.fontSubColorDark)};
    background-color:transparent;
  }
  input{
    color:${()=>setThemeVars( configStyles.fontColorLight,configStyles.fontColorDark)};
    background:transparent;
  }
  .gsc-modal-background-image{
    background-color:${()=>setThemeVars( configStyles.bgColorLight,configStyles.bgColorDark)};
  }
`